<template lang="pug">
  .page
    section
      b-container
        h1.mt-0(v-if="this.rental") RENTAL OVERVIEW
        .breadcrumbs.text-muted.small.py-3
          router-link(:to="{name: 'AccountRentals'}")
            font-awesome-icon.mr-2(icon="caret-left")
            span ALL RENTALS
        .row(v-if="rental")
          .col-md-6
            b-card.mb-3
              .container
                p Details
                ul.list-unstyled
                  li
                      span.font-weight-bold From
                      span.ml-1 {{ rental.date_start_pretty }}
                  li
                    span.font-weight-bold Renews
                    span.ml-1 {{ rental.date_end_pretty }}
                  li
                    span.font-weight-bold Listed price
                    span.ml-1 {{ formatRands(rental.base_price)  }}
                  li
                    span.font-weight-bold Rental spend
                    span.ml-1 {{ formatRands(rental.rental_spend) }}
                  li
                    span.font-weight-bold Discount
                    span.ml-1 {{ `${rental.conversion_discount_rate}%` }}
                  li
                    span.font-weight-bold Keep it for
                    span.ml-1 {{ formatRands(rental.conversion_price) }}
                //- .text-left(v-if="rental.status == 'active'")
                    button-load(type="submit", :flag="flags.cancelRental", label="CANCEL RENTAL", classes="btn-outline", @clicked="cancelRental()")
          .col-md-6
            b-card.mb-3(v-if="rental.status == 'active'")
              .container.text-center
                h4 Return this rental
                p Simply cancel here and we'll book a return for you
                button-load(type="submit", :flag="flags.cancelRental", label="CANCEL RENTAL", classes="btn-outline", @clicked="cancelRental()")
            b-card.mb-3(v-if="rental.status == 'active'")
              .container.text-center
                b-collapse#collapseKeepRentalIntro(:visible="true")
                  h4 Fallen in love?
                  p {{ `You can keep this piece for ${formatRands(rental.conversion_price)}` }}
                  // b {{ `keep it for ${formatRands(rental.conversion_price)}.` }}
                  b-button.btn-outline(v-b-toggle="['collapseKeepRentalIntro', 'collapseKeepRentalFinish']") {{ `I'M KEEPING IT` }}
                b-collapse#collapseKeepRentalFinish
                  h4 LET'S MAKE IT OFFICIAL
                  p We will charge the remaining amount to your credit card, making you the outright owner of this piece.
                  b-form-group
                      b-form-checkbox(v-model='aggree', switch) {{ `I authorise Wall to charge ${formatRands(rental.conversion_price)} to my credit card` }}
                  button-load(type="submit", :flag="flags.keepRental", label="CONFIRM", classes="btn-outline", @clicked="keepRental()")
            b-card.mb-3(v-else-if="rental.status === 'cancelled'")
              .container.text-center
                h4 RENTAL CANCELLED
                p
                  | A return will be scheduled once the current period is over, on
                  |
                  b {{ rental.date_end_pretty }}
                // b-button.btn-outline(@click="resumeRental()") REACTIVATE
            b-card.mb-3(v-else-if="rental.return_shipment")
              .container.text-center
                h4 RETURN SHIPMENT
                div
                  p
                    |{{ `On ${rental.return_shipment.created_pretty}, a return has been booked with tracking number: ${rental.return_shipment.tracking_number}` }}
                    b
                  p.small
                    | Please see our
                    |
                    a.text-primary(:to="{ name: 'help' }") FAQ
                    |
                    | section for pickup time estimates
                  b-button.btn-outline(:href="`https://optimise.parcelninja.com/shipment/track/${rental.return_shipment.tracking_number}`" target="_blank") TRACK PICKUP
            // b-card(v-else-if="rental.days_left < 300 && rental.status === 'active'")
              .container
                h6 Schedule pickup
                b-form.pb-0(@submit.prevent="onSubmit()")
                  span.small Pickup an available day
                  b-form-datepicker(required, v-model="inputForm.return_date", :min="dateMin", :max="dateMax", locale="en", placeholder="When can the couriers swing by?")
                  span.small Address
                  p.mb-1 {{ `${rental.address.line_1}, ${rental.address.line_2?rental.address.line_2+',':''} ${rental.address.suburb}, ${rental.address.city}, ${rental.address.zip}` }}
                  router-link.small(:to="{name: 'AccountAddress'}") Change Address
                  .text-right.pt-2
                    button-load(type="submit", :flag="alert.busy", label="Schedule Now", classes="btn-outline")
            // p(v-else="") No return scheduled yet
        content-loader(:height="7", v-else-if="alert.loading")
        p(v-else="") Rental not found
</template>

<script>

import { apiService } from '@/services';
import standardMix from '@/mixins/standardMix';
import router from '@/router';

export default {
  name: 'Rental',
  mixins: [standardMix],
  data() {
    return {
      rental: null,
      aggree: false,
      fields: [
        { key: 'compTitle', label: 'Item', sortable: true },
        { key: 'compShipmentStatus', label: 'Shipment' },
        { key: 'shipment_eta', label: 'ETA' },
        // { key: 'actions', label: '' },
      ],
      inputForm: {
        return_date: '',
      },
      dateMin: '',
      dateMax: '',
      flags: {
        cancelRental: false,
        resumeRental: false,
        keepRental: false,
      },
    };
  },
  computed: {
  },
  methods: {
    async cancelRental() {
      try {
        this.flags.cancelRental = true;
        await apiService.cancelRental(this.rental.id);
        this.rental.status = 'cancelled';
        this.success('Rental cancelled');
      } catch (error) {
        this.error('Could not cancel rental');
      }
      this.flags.cancelRental = false;
    },
    async resumeRental() {
      try {
        this.flags.resumeRental = true;
        await apiService.resumeRental(this.rental.id);
        this.rental.status = 'active';
        this.success('Rental resumed');
      } catch (error) {
        this.error('Could not resume rental');
      }
      this.flags.resumeRental = false;
    },
    async keepRental() {
      if (this.aggree) {
        try {
          this.flags.keepRental = true;
          await apiService.keepRental(this.rental.id);
          router.push({ name: 'KeepOkay' });
        } catch (error) {
          this.error('Could not complete purchase');
        }
        this.flags.keepRental = false;
      } else {
        this.error('Please aggree to our terms');
      }
    },
    async onSubmit() {
      if (this.inputForm.return_date) {
        try {
          this.loading();
          const newRental = await apiService.scheduleRentalReturn(this.inputForm, this.$route.params.rentalId);
          this.rental = newRental;
          console.log(newRental.status);
          // this.rental = await apiService.getRental(this.$route.params.rentalId);
          this.clear();
        } catch (error) {
          this.error('Could not schedule return');
        }
      } else if (this.inputForm.return_date > this.dateMax || this.inputForm.return_date < this.dateMin) {
        this.error('Please choose a day within the limits');
      } else {
        this.error('Please specify a pickup date');
      }
    },
  },
  async created() {
    if (this.$route.params.rentalId) {
      try {
        this.loading();
        this.rental = await apiService.getRental(this.$route.params.rentalId);
        const date = new Date(this.rental.date_end);
        // const day = date.getDate();
        this.dateMin = new Date(this.rental.date_end);
        this.dateMin.setDate(date.getDate() - 5);
        this.dateMax = new Date(this.rental.date_end);
        this.dateMax.setDate(date.getDate() + 5);
        this.clear();
      } catch (error) {
        this.error('Rental not found');
      }
    }
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/Rental.vue